import React from "react";
import { Alert } from "@mui/material";

const APIMessage = (props) => {
  return <Alert {...props}>{props.message}</Alert>;
};

export default APIMessage;
